// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { nullPage } from "@insite/client-framework/Store/Data/Pages/PagesState";
import {
    chain,
    LoadCartIfNeeded,
} from "@insite/client-framework/Store/Pages/RfqRequestQuote/Handlers/LoadAccountsIfNeeded";

/**
 * XNG-Changes
 * Add waitFor before loadCartCurrent to make sure getCurrentPage(props.getState()) return real page type
 * and make the custom code in loadCartCurrent work fine
 * "We need it to prevent stop render on RequestQuotePage"
 */
export const DispatchBeginLoadCart: typeof LoadCartIfNeeded = async props => {
    await waitFor(() => getCurrentPage(props.getState()) !== nullPage);
};

addToChainBefore(chain, LoadCartIfNeeded, DispatchBeginLoadCart);
